import { Button, Label, Modal, TextInput } from "flowbite-react";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaRegTimesCircle } from "react-icons/fa";
import { HiOutlineDocumentAdd, HiOutlineSearch } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import swal from "sweetalert2";
import { getAllProducer } from "../../../redux/producerReducer";
import Loading from "../../Global/Loading";
import AddProduct from "../AddProduct";
import NewProducer from "../NewProducer";
import './newproduct.scss';

function Product(props) {
    const { t } = useTranslation();
    const { globalState, producerState } = useSelector((state) => state);
    const { producers, getAllProducerState } = producerState;

    const dispatch = useDispatch();

    const [modalShow, setModalShow] = useState(false); //modal modalShow hide
    const [producer, setProducer] = useState(null); //modal modalShow hide
    const [search, setSearch] = useState(""); //search bar text
    const [searchResShow, setSearchResShow] = useState(false);

    const changeSearch = (e) => {
        setSearch(e.target.value);
        setProducer(null);
        dispatch(getAllProducer(e.target.value));
        if (e.target.value) {
            setSearchResShow(true);
        } else {
            setSearchResShow(false);
        }
    };

    const selectProducer = (_id, name) => {
        setSearch(name);
        setProducer({ _id, name });
        setSearchResShow(false);

        //_id code here
    };

    const closeModal = () => {
        swal
            .fire({
                title: t("swal_are_you_sure"),
                text: t("swal_leave_page"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: t("swal_leave"),
            })
            .then((result) => {
                if (result.isConfirmed) {
                    close();
                }
            });
    };

    const closeModalWithOutSwal = () => {
        close();
    };

    function close() {
        setModalShow(false);
        setSearch("");
        setSearchResShow(false);
        setProducer(null);
    }

    return (
        <>
            {/* <Button color={'red'} onClick={() => setModalShow(true)} outline={true} className="group w-full button-nowrap !bg-sitebg-50 hover:!bg-sitebg-50 transition-color duration-150">
                <HiOutlineDocumentAdd className="mr-2 h-6 w-6 text-sitebg-50 group-hover:text-white transition-color duration-150" />
                {t("add_new_product")}
            </Button> */}
            <div onClick={() => setModalShow(true)} className="btn-newproduct bg-indigo-500 text-white hover:bg-indigo-400">
                {/* <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M15.3999 7H9.3999V1C9.3999 0.4 8.9999 0 8.3999 0C7.7999 0 7.3999 0.4 7.3999 1V7H1.3999C0.799902 7 0.399902 7.4 0.399902 8C0.399902 8.6 0.799902 9 1.3999 9H7.3999V15C7.3999 15.6 7.7999 16 8.3999 16C8.9999 16 9.3999 15.6 9.3999 15V9H15.3999C15.9999 9 16.3999 8.6 16.3999 8C16.3999 7.4 15.9999 7 15.3999 7Z"
                        fill="white"
                    />
                </svg> */}
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" className="h-4 w-4" viewBox="0 0 24 24">
                <path className="st0 " d="M22.4,17.4l-5,5c-0.6,0.6-1.3,0.9-2.1,0.9H3.8c-1.7,0-3-1.3-3-3V3.8c0-1.7,1.3-3,3-3h16.5c1.7,0,3,1.3,3,3l0,0
                    v11.5C23.3,16.1,22.9,16.8,22.4,17.4z"/>
                <path className="st0" d="M15.8,23.2v-4.5c0-1.7,1.3-3,3-3h4.5"/>
                <line className="st0" x1="12" y1="7.5" x2="12" y2="16.5"/>
                <line className="st0" x1="7.5" y1="12" x2="16.5" y2="12"/>
                </svg>
                <div className="hidden md:flex">{t("add_new_product")}</div>
            </div>
            <Modal
                show={modalShow}
                size="md"
                popup={true}
                onClose={() => closeModal()}>
                <Modal.Header className="px-6 py-4">
                    {t("add_new_product")}
                </Modal.Header>
                <hr />
                <Modal.Body className="overflow-y-auto !py-0">
                    <div className="py-6">
                        <div>
                            <div className="mb-2 ml-2 block">
                                <Label
                                    htmlFor="searchproducer"
                                    className="text-lg"
                                    value={t("search_producer")}
                                />
                            </div>
                            <TextInput
                                id="searchproducer"
                                type="search"
                                sizing="lg"
                                placeholder={t("what_are_looking")}
                                required={true}
                                icon={HiOutlineSearch}
                                value={search}
                                onChange={(e) => changeSearch(e)}
                            />
                            {getAllProducerState && <Loading />}
                            {searchResShow && (
                                <>
                                    <div className="max-h-72 overflow-auto">
                                        {producers?.length > 0 &&
                                            producers.map((data, index) => (
                                                <div
                                                    className="text-sm"
                                                    key={index}
                                                    onClick={() => selectProducer(data._id, data.name)}
                                                >
                                                    <div className="grid grid-cols-2 cursor-pointer text-gray-700 hover:text-blue-400 hover:bg-blue-100 rounded-md px-2 py-2 my-2">
                                                        <div className="flex-grow font-medium px-2">
                                                            {data.name}
                                                        </div>
                                                        <div className="text-sm font-normal text-gray-500 tracking-wide">
                                                            {data.country?.name[`${globalState.language}`] +
                                                                ", " +
                                                                data.region?.name[`${globalState.language}`]}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>

                                    <NewProducer
                                        closePrevModal={closeModalWithOutSwal}
                                        condition={props.condition}
                                    />
                                </>
                            )}
                        </div>

                        <div className="mt-2 ml-2 text-sm block text-sitetx-100">
                            {t("not_producer_create_new")}
                        </div>
                    </div>
                </Modal.Body>
                <hr />
                <Modal.Footer>
                    <div className="flex flex-wrap gap-4 m- flex-system-space-around auto" >
                        <div>
                            <Button
                                color={"red"}
                                onClick={() => closeModal()}
                                className="btn border-slate-200 hover--border-slate-300 text-indigo-500">
                                {t("dismiss")}
                                {/* <FaRegTimesCircle className="ml-2 h-5 w-5" /> */}
                                 <svg className="ml-2 h-5 w-5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5">
                                    <path d="M15.182 8.818L8.818 15.181" fill="none" stroke="blue" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M8.818 8.818L15.182 15.181" fill="none" stroke="blue" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z" fill="none" stroke="blue" stroke-linecap="round" stroke-linejoin="round"/></svg>
                            </Button>
                        </div>
                        <div>
                            <AddProduct
                                producer={producer}
                                closePrevModal={closeModalWithOutSwal}
                                type="fromProduct"
                                condition={props.condition}/>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default Product;
